const durationString = (minutes: number) => {
  const d = Math.floor(minutes / (60 * 24));
  const h = Math.floor((minutes % (60 * 24)) / 60);
  const m = Math.floor((minutes % 60) % 60);

  const dDisplay = d > 0 ? `${d} day${d > 1 ? 's' : ''}` : '';
  const hDisplay = h > 0 ? `${h} hour${h > 1 ? 's' : ''}` : '';
  const mDisplay = m > 0 ? `${m} minute${m > 1 ? 's' : ''}` : '';
  const parts = [dDisplay, hDisplay, mDisplay].filter((p) => p !== '');
  return parts.join(' ');
};

export default durationString;
